import React from "react";
import PropTypes from "prop-types";
import "react-quill/dist/quill.snow.css";
var toolbarOptions = [
    ["bold", "italic", "underline", "strike"],
    ["blockquote", "code-block"],

    [{ "header": 1 }, { "header": 2 }],
    [{ "list": "ordered" }, { "list": "bullet" }],
    [{ "script": "sub" }, { "script": "super" }],
    [{ "indent": "-1" }, { "indent": "+1" }],
    [{ "direction": "rtl" }],
    [{ "size": ["small", false, "large", "huge"] }],
    [{ "header": [1, 2, 3, 4, 5, 6, false] }],
    [{ "color": [] }, { "background": [] }],
    [{ "font": [] }],
    [{ "align": [] }],
    ["clean"]
];
class WordEditor extends React.Component {
    handleChange = (value) => {
        // console.log(this.ReactQuill.getContents());
        this.props.onEdit(value);
    };

    componentDidMount() {
        return import(/* webpackChunkName: "reactquill" */ "react-quill")
            .then(_ => _.default)
            .then(ReactQuill => {
                this.ReactQuill=ReactQuill;
                this.forceUpdate();
            });
    }


    render() {
        if(!this.ReactQuill) {
            return null;
        }
        return (
            <this.ReactQuill
                value={this.props.value}
                onChange={this.handleChange}
                className={this.props.className}
                readOnly={this.props.readOnly}
                placeholder={this.props.placeholder}
                onBlur={this.props.onBlur}
                modules={{
                    toolbar: toolbarOptions
                }}
            />
        );
    }
}

WordEditor.propTypes = {
    value: PropTypes.string,
    onEdit: PropTypes.func,
    readOnly: PropTypes.bool,
    className: PropTypes.string,
    placeholder: PropTypes.string,
    onBlur: PropTypes.func,
    style: PropTypes.object
};

WordEditor.defaultProps = {
    readOnly: false,
    placeholder: ""
};

export default WordEditor;
